var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",style:({
    width: _vm.width + 'px',
    height: _vm.anchor + 'px',
    margin: ("-" + _vm.anchor + "px 0 0 -" + (_vm.width/2) + "px"),
    fill: _vm.fill,
    color: _vm.color,
    stroke: _vm.strokeColor
  })},[_c('svg',{attrs:{"viewBox":"0 0 155 200"}},[_c('use',{attrs:{"xlink:href":"#markerIcon"}})]),_c('div',{style:({
      width: _vm.width + 'px',
      height: _vm.width + 'px'
    })},[(_vm.type === 'img')?_c('q-img',{style:({
        width: _vm.iconSize + 'px',
        height: _vm.iconSize + 'px'
      }),attrs:{"src":_vm.icon}}):_c('q-icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize + 'px'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }